import {useQuery} from "@tanstack/react-query";
import {getRoleQueryOptions} from "./get-role.query-options";

export function useGetRole(roleId: string) {
  return useQuery(getRoleQueryOptions(roleId));
}
